import {
  Box, Group, Image, Text, UnstyledButton, ActionIcon, useMantineTheme
} from '@mantine/core';
import '@mantine/core/styles.css';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useCallback } from 'react';

import { IconArrowLeft } from '@tabler/icons-react';

import classes from './Header.module.css';
import Logo from '../../assets/ensis-logo.svg';
import { getSplitLocation } from '../../utils/stringUtils';
import UserAvatarMenu from '../DropdownMenus/UserAvatarMenu';
import useEnsisQuery from '../../hooks/useEnsisQuery';

const Header: React.FC = () => {
  const { organization, proposalUid } = useParams();

  const location = useLocation();
  const splitLocation = getSplitLocation(location);
  const navigate = useNavigate();
  const { other: colorVars } = useMantineTheme();
  const isSetupRoute = splitLocation.includes('setup-proposal');

  const showBackArrow = isSetupRoute;
  const handleBackArrowClick = useCallback(() => {
    navigate(`/org/${organization}/proposals`);
  }, [organization]);
  const { data } = useEnsisQuery(`/app/proposals/${proposalUid}/data`, {
    enabled: isSetupRoute
  });
  const backArrow = (
    <ActionIcon
      variant='subtle'
      onClick={handleBackArrowClick}
    >
      <IconArrowLeft color={colorVars.primaryIconColor} />
    </ActionIcon>
  );

  return (
    <Group className={classes.headerRoot} justify='space-between'>
      <Group>
        <Box display="flex" style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
          {showBackArrow
            ? backArrow
            : <UnstyledButton onClick={() => { navigate(`/org/${organization}`); }}>
              <Image src={Logo} fit='contain' width='auto' />
            </UnstyledButton>
          }
        </Box>
        {isSetupRoute && (
          <Text fz='sm' fw={500}>
            {data?.name}
          </Text>
        )}
      </Group>
      <UserAvatarMenu />
    </Group>
  );
};

export default Header;
